import { useTranslation } from 'react-i18next';
import { Navigation } from '@cbridge-utils/navigation';
import { RouteSegments } from '../routingClientAdmin.interface';

export const useConfigSymbolsNavigationItems = () => {
  const { t } = useTranslation();

  const items: Navigation = [
    {
      kind: 'header',
      title: t('text:navigation.config.symbols.title'),
    },
    {
      kind: 'page',
      segment: `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Core}`,
      pattern: `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Core}{/*path}`,
      title: t('text:navigation.config.symbols.core'),
    },
    // TODO LB-3919: unhide Synthetic Symbols once the backend is ready (page stays reachable via direct URL)
    // {
    //   kind: 'page',
    //   segment: `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Synthetic}`,
    //   pattern: `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Synthetic}{/*path}`,
    //   title: t('text:navigation.config.symbols.synthetic'),
    // },
    {
      kind: 'page',
      segment: `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Client}`,
      pattern: [
        `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Client}`,
        `${RouteSegments.Pools.Symbols}{/*path}`,
        `${RouteSegments.Servers.Symbols}{/*path}`,
      ],
      title: t('text:navigation.config.symbols.client'),
    },
    {
      kind: 'page',
      segment: `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.LP}`,
      pattern: [
        `${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.LP}{/*path}`,
        `${RouteSegments.Lps.Symbols}{/*path}`,
      ],
      title: t('text:navigation.config.symbols.lp'),
    },
  ];

  return items;
};
